import { CheckCircle, Camera, FileText, Plus, ArrowRight } from 'lucide-react';

const ACTION_CONFIG = {
  phase_validate: { icon: CheckCircle, color: 'text-carex-600', label: 'Phase validée' },
  create: { icon: Plus, color: 'text-blue-600', label: 'Dossier créé' },
  status_change: { icon: ArrowRight, color: 'text-orange-600', label: 'Statut modifié' },
  generate_report: { icon: FileText, color: 'text-purple-600', label: 'Rapport généré' },
  photo_upload: { icon: Camera, color: 'text-emerald-600', label: 'Photos ajoutées' },
};

function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

/**
 * Timeline verticale des actions récentes sur un dossier.
 */
export default function ActivityTimeline({ activities = [] }) {
  if (activities.length === 0) {
    return (
      <div className="text-sm text-slate-400 text-center py-8">
        Aucune activité récente
      </div>
    );
  }

  return (
    <div className="border-l-2 border-slate-100 pl-4 space-y-4">
      {activities.map((activity, idx) => {
        const config = ACTION_CONFIG[activity.action] || ACTION_CONFIG.create;

        return (
          <div key={idx} className="relative">
            <div
              className={`absolute -left-[21px] top-0.5 w-3 h-3 rounded-full border-2 border-white ${config.color.replace('text-', 'bg-')}`}
            />
            <div className="text-xs font-semibold text-slate-900">
              {activity.description || config.label}
            </div>
            <div className="text-[10px] text-slate-500">
              {activity.user_name && `Par ${activity.user_name} — `}
              {formatDate(activity.created_at)}
            </div>
          </div>
        );
      })}
    </div>
  );
}
